import { withState } from 'recompose';

export default withState(
  'accountHolderType',
  'updateAccountHolderType',
  'individual'
);
